import { render, staticRenderFns } from "./ResultEnroll.vue?vue&type=template&id=6ddfe1c0&"
import script from "./ResultEnroll.vue?vue&type=script&lang=js&"
export * from "./ResultEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports